import { render, staticRenderFns } from "./ViewPacking.vue?vue&type=template&id=1a9c2345&"
import script from "./ViewPacking.vue?vue&type=script&lang=js&"
export * from "./ViewPacking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports